import { render, staticRenderFns } from "./PinchZoom.vue?vue&type=template&id=5f41dc3a"
import script from "./PinchZoom.vue?vue&type=script&lang=ts"
export * from "./PinchZoom.vue?vue&type=script&lang=ts"
import style0 from "./PinchZoom.vue?vue&type=style&index=0&id=5f41dc3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports